import { render, staticRenderFns } from "./DataReportEarnedStatistics.vue?vue&type=template&id=a34081dc&scoped=true"
import script from "./DataReportEarnedStatistics.vue?vue&type=script&lang=js"
export * from "./DataReportEarnedStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataReportEarnedStatistics.vue?vue&type=style&index=0&id=a34081dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34081dc",
  null
  
)

export default component.exports